import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList, faAngleRight } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

const services = [
  { name: "Bulk SMS", path: "/bulk-sms" },
  {
    name: "Interactive Voice Response",
    path: "/interactive-voice-response",
  },
  { name: "Inventory Management", path: "/inventory-management" },
  {
    name: "Leads Management System",
    path: "/leads-management-system",
  },
  { name: "Virtual Phone Number", path: "/virtual-phone-number" },
  {
    name: "Missed Call Alert Services",
    path: "/missed-call-alert-services",
  },
  { name: "Customer Relationship", path: "/customer-relationship" },
  {
    name: "Employee Tracking System",
    path: "/employee-tracking-system",
  },
];

const ProductSideService = () => {
  return (
    <div>
      <h2 className="font-semibold text-center text-lg mb-1">
        All Our Product
      </h2>

      <div className=" w-20 h-1 bg-main mx-auto mb-2 rounded-full" />

      <div className="bg-[#ECF1F6] rounded p-4 shadow-md sticky top-20 w-full max-w-sm">
        {/* Header */}

        <div className="flex items-center gap-1 mb-2">
          <div className="bg-gradient-to-b from-[#456789] to-[#1a2a3a] px-[6px] rounded-md">
            <FontAwesomeIcon icon={faList} className="text-white text-sm" />
          </div>
          <h3 className="md:text-lg text-base  font-semibold text-gray-800">
            Products
          </h3>
        </div>

        {/* Services List */}
        <div className=" bg-white ">
          {services.map((service, index) => (
            <Link
              to={service.path}
              key={index}
              className="flex justify-between no-underline items-center px-3 py-[10px]  hover:bg-[#ECF1F6] transition-all duration-200 cursor-pointer text-sm font-medium text-gray-700"
            >
              <span className=" text-sm md:text-[15px]">{service.name}</span>
              <FontAwesomeIcon icon={faAngleRight} className="text-main  " />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductSideService;
